import { getAxiosInstance } from '../api.client';
import {
    type BatchUpdateOperativeRatesRequest,
    type Operative,
    type OperativeFormModel,
    OperativeStatus,
} from './operatives.models';

export async function getOperatives(): Promise<Operative[]> {
    const response = await getAxiosInstance().get<Operative[]>('/Operative');
    return response.data;
}

export async function getOperativeById(id: string): Promise<Operative> {
    const response = await getAxiosInstance().get<Operative>(
        `/Operative/${id}`,
    );
    return response.data;
}

export async function createOperative(
    data: OperativeFormModel,
): Promise<Operative> {
    const response = await getAxiosInstance().post<Operative>(
        '/Operative',
        data,
    );
    return response.data;
}

export async function updateOperative(
    id: string,
    data: OperativeFormModel,
): Promise<Operative> {
    const response = await getAxiosInstance().put<Operative>(
        `/Operative/${id}`,
        data,
    );
    return response.data;
}

export async function changeOperativeStatus(
    id: string,
    status: OperativeStatus,
): Promise<Operative> {
    const response = await getAxiosInstance().patch<Operative>(
        `/Operative/${id}/status`,
        null,
        {
            params: { status },
        },
    );
    return response.data;
}

export async function deleteOperative(id: string): Promise<void> {
    await getAxiosInstance().delete(`/Operative/${id}`);
}

export async function batchUpdateOperativeRates(
    data: BatchUpdateOperativeRatesRequest,
): Promise<Operative[]> {
    const response = await getAxiosInstance().put<Operative[]>(
        '/Operative/batch-update-rates',
        data,
    );
    return response.data;
}
